import { actions } from "@mixitone/actions";

/**
 * Starts club Akahu OAuth onboarding and redirects the browser to Akahu.
 */
export async function startClubAkahuOnboarding(options: {
  clubId: string;
  returnPath: string;
}): Promise<void> {
  const response = await actions.akahu.startClubOnboarding({
    clubId: options.clubId,
    flow: "club_onboarding",
    returnPath: options.returnPath,
  });

  const redirectUrl = response.redirectUrl || response.authorisationUrl || response.authorizationUrl;
  if (!redirectUrl) {
    throw new Error("Could not open the bank page");
  }

  window.location.assign(redirectUrl);
}
